import {useMediaQuery} from 'react-responsive';
import styled from 'styled-components';

import {IconProps} from 'shared/Icons/types';
import {Breakpoints, IconSize} from 'styles/Base';
import {Colors} from 'styles/Colors';

interface Props {
  props: IconProps;
  className?: string; // this is required for styled components support
  'data-testid'?: string;
}

export const isStyledIconProps = (obj: any): obj is Props => obj.props !== undefined && obj.props['url'] !== undefined;

const getWidth = (size: IconSize, isResponsive: boolean, isTablet: boolean) => {
  if (isResponsive) {
    if (isTablet) {
      switch (size) {
        case IconSize.PX_24:
          return {width: '20px', height: '20px'};
        default:
          return {width: '33px', height: '33px'};
      }
    }
  }
  const sizeInPX = `${size}px`;
  return {width: sizeInPX, height: sizeInPX};
};

const Svg = styled.svg<{url: string; color: Colors}>`
  mask: ${({url: src}) => `url(${src})`};
  background-color: ${({color}) => color};
`;

const StyledIcon = ({props, className, 'data-testid': dataTestId}: Props) => {
  const isTablet = useMediaQuery({query: `(${Breakpoints.TABLET})`});

  const {
    css = typeof props.css === 'function' ? props.css(isTablet) : {...props.css},
    url,
    size = IconSize.PX_45,
    isResponsive = false,
    'aria-label': ariaLabel,
    color = Colors.PINE_GREEN,
    svgProps
  } = props;
  const style = getWidth(size, isResponsive, isTablet);
  const {key, ...spreadableSVGProps} = {...svgProps};

  return (
    <span className={className} style={{display: 'flex', alignItems: 'center', ...css}}>
      <Svg
        role={ariaLabel ? 'img' : undefined}
        aria-label={ariaLabel ?? undefined}
        role-img-alt={ariaLabel}
        aria-hidden={!ariaLabel}
        {...{url, color, style}}
        {...spreadableSVGProps}
        data-testid={dataTestId ? `${dataTestId}-${url}` : undefined}
      />
    </span>
  );
};

export default StyledIcon;
